import React from "react";

const StudentLifeCard = ({ item, onClick }) => {
  return (
    <div className="flex flex-col h-full relative group">
      <div className="flex-1">
        <div
          className="rounded-3xl overflow-hidden shadow-xl bg-white flex flex-col h-full group transition-all duration-500 hover:scale-105 hover:-translate-y-2 hover:shadow-2xl cursor-pointer"
          onClick={() => onClick(item)}
        >
          <div className="relative">
            <img
              src={item["images/videos"]}
              alt={item.title || item.name}
              referrerPolicy="no-referrer"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/about/mech.jpg";
              }}
              className="w-full h-56 object-cover border-2 border-transparent group-hover:border-blue-600 transition-all duration-300"
            />
          </div>
          <div className="p-6 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-black mb-2 line-clamp-2 font-manrope">
              {item.title || item.name}
            </h3>
            <p className="text-gray-600 text-base mb-4 line-clamp-3">
              {item.description}
            </p>
            {item.category && (
              <span className="inline-block bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full mt-auto self-start">
                {item.category}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentLifeCard;
